export default __webpack_public_path__ + "static/media/top-bar.71c8343c.png";